import type { SpacingToken } from "..";

export function destructSpacing(
  margin?:
    | SpacingToken
    | [
      top?: SpacingToken,
      right?: SpacingToken,
      down?: SpacingToken,
      left?: SpacingToken,
    ],
): [SpacingToken, SpacingToken, SpacingToken, SpacingToken] {
  let [marginTop, marginRight, marginBottom, marginLeft] =
    typeof margin === "string"
      ? [margin, margin, margin, margin]
      : Array.isArray(margin)
      ? margin
      : (["$spacing-0", "$spacing-0", "$spacing-0", "$spacing-0"] as const);
  marginTop ??= "$spacing-0";
  marginRight ??= marginTop;
  marginBottom ??= marginTop;
  marginLeft ??= marginRight;

  return [marginTop, marginRight, marginBottom, marginLeft];
}

export const joinClassNames = (classNames: Array<string | undefined>): string =>
  classNames.filter((name) => name).join(" ");
